var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconComputer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 53,
    viewBox: "0 0 58 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICON COMPUTER"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.8887 2.41316C20.8887 2.41316 45.6787 10.551 52.6689 13.2591C54.8515 14.1497 53.3015 17.5885 51.9258 21.182C50.5501 24.7754 46.6354 35.591 46.6354 35.591L12.0447 23.719C13.8607 19.7994 17.5701 6.13405 18.0809 4.88938C18.5918 3.64472 19.4147 2.12492 20.8947 2.41507L20.8887 2.41316Z",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.772 24.3027C11.772 24.3027 4.89558 31.9772 2.91096 33.8156C0.926329 35.6541 2.40139 37.5814 11.3557 40.1163C22.754 43.3425 43.3398 50.5932 43.3398 50.5932C43.3398 50.5932 47.2006 51.6071 46.8588 47.2328C46.517 42.8584 46.2196 35.7998 46.2196 35.7998",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.9949 41.1672C16.9949 41.1672 17.3825 36.7963 22.5559 38.5403C25.9126 39.669 28.2576 40.5458 29.4939 41.0211C30.4655 41.3984 31.1874 42.1234 31.3711 42.926C31.5361 43.6634 31.4905 44.6887 30.8279 46.0163",
    stroke: "#EF7056",
    strokeWidth: 3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconComputer);
export default __webpack_public_path__ + "static/media/icon-computer.79c97cc8002408263f58cabe2454dd47.svg";
export { ForwardRef as ReactComponent };